<template>
  <app-dropdown class="select"
                :class="{ 'select_small': small }"
                ref="dropdown"
                :data-button-gradient="buttonGradient"
                :data-border="border"
                :data-title="title"
                :data-image="image"
                :data-menu-heading="menuHeading"
                :data-menu-width="menuWidth"
                :data-menu-height="menuHeight"
                :data-show-clear="canClear && clearable"
                :titleMaxWidth="titleMaxWidth"
                :readonly="readonly"
                :disabled="disabled"
                @clear="set(null)"
                @opened="emitOpened"
                @hidden="onDropdownHidden">

    <app-search-bar v-if="dataSearch"
                    ref="searchBar"
                    @enter="emitSearch" />

    <slot />

    <template v-if="!$slots.default">
      <template v-if="multiple">
        <v-chip close
                v-for="item in dataItems"
                :selected="false"
                :value="value.includes(item.id)"
                :key="item.id"
                @input="remove(item.id)">{{item.label}}
        </v-chip>
      </template>

      <ul v-if="noResults">
        <li class="noResults">{{$t('message.generics.message.noResultsFound')}}</li>
      </ul>

      <ul v-else
          :style="{'max-height': dataMaxHeight}">
        <template v-for="item in items">
          <li @click="set(item)"
              :key="item.key">
            <img v-if="item.imgSrc"
                 :src="item.imgSrc"
                 :alt="item.imgAlt"
                 class="li-img">
            {{item.label}}
          </li>
        </template>
      </ul>

      <infinite-loading v-if="infiniteLoading"
                        :identifier="loadingId"
                        @infinite="load">
        <div class="infinite-text"
             slot="no-results">{{$t('message.generics.message.noResultsFound')}}</div>
        <div class="infinite-text"
             slot="no-more"></div>
      </infinite-loading>

    </template>

  </app-dropdown>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import AppDropdown from "@components/Dropdown";
import AppSearchBar from "@components/Search";
import _ from "lodash";
import dropdownMenuProps from "@mixins/dropdown/dropdown-menu-props";
import dropdownButtonProps from "@mixins/dropdown/dropdown-button-props";

export default {
  components: {
    AppDropdown,
    AppSearchBar,
    InfiniteLoading,
  },

  data() {
    return {
      interanalInfiniteId: Date.now(),
    };
  },

  props: {
    value: {},

    dataItems: {
      type: Array,
    },

    dataMaxHeight: {
      type: String,
    },

    dataSearch: {
      type: Boolean,
      default: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    infiniteLoading: {
      type: Boolean,
      default: false,
    },

    infiniteId: {
      type: Number,
    },

    small: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    noResults: {
      type: Boolean,
      default: false,
    },

    titleMaxWidth: {
      type: String,
    },
  },

  computed: {
    loadingId() {
      return this.infiniteId || this.interanalInfiniteId;
    },
    selected() {
      if (!this.multiple)
        return _.find(this.dataItems, (item) => {
          return item.id === this.value;
        });

      return _.filter(this.dataItems, (item) => {
        return this.value.includes(item.id);
      });
    },

    items() {
      if (!this.multiple) return this.dataItems;

      return _.filter(this.dataItems, (item) => {
        return !this.value.includes(item.id);
      });
    },

    title() {
      if (this.multiple) return this.dataTitle;

      return this.selected ? this.selected.label : this.dataTitle;
    },

    image() {
      return this.selected
        ? this.selected.imgSrc
          ? { imgSrc: this.selected.imgSrc, imgAlt: this.selected.imgAlt }
          : null
        : null;
    },

    canClear() {
      return !!this.selected && !this.multiple;
    },
  },

  methods: {
    emitSearch(text) {
      this.$emit("search", text);
    },
    emitOpened() {
      this.$emit("opened");
    },
    onDropdownHidden() {      
      this.resetSearch()
      
      this.$emit('hidden')
    },
    resetSearch() {
      if (this.$refs.searchBar) {
        this.$refs.searchBar.setNullValue()
      }
    },
    load($state) {
      this.$emit("load", $state);
    },
    set(item) {
      if (this.readonly) return;

      if (this.multiple)
        return this.$emit(
          "input",
          item === null ? undefined : [...this.value, item.id]
        );

      this.$emit("input", item ? item.id : item);
      this.onDropdownHidden()
      this.$refs.dropdown.close();
    },

    remove(removeId) {
      if (this.readonly) return;

      this.$emit(
        "input",
        _.filter(this.value, (id) => {
          return removeId !== id;
        })
      );
    },
  },

  mixins: [dropdownMenuProps, dropdownButtonProps],
};
</script>

<style lang="scss" scoped>
.select {
  width: min-content;

  &.select_small {
    ::v-deep .dropdown-title {
      font-size: 14px;
    }

    ::v-deep .dropdown-btn {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

ul {
  margin-top: 10px;
  padding: 0;
  overflow-y: auto;
  text-align: left;

  li {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 5px 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;

    &:hover {
      font-weight: bold;
      white-space: normal;
    }

    .li-img {
      align-self: flex-start;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .noResults {
    cursor: auto;

    &:hover {
      font-weight: normal;
      white-space: normal;
    }
  }
}

.infinite-text {
  font-size: 12px;
}
</style>
